import React from 'react';
import _ from 'underscore';

import {DataConnectSiteSettingsCoordinator} from '~src/settings/dataconnect-settings/DataConnectSiteSettingsCoordinator';
import {subspaceStyle} from '~src/settings/styles/CommonStyles';
import { ISiteDataConnectSettingsForSiteAdmin } from '~src/settings/types/ISiteAdminDataConnectSettings';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { RouterError } from '../../../../bootstrap/routerHelpers/RouterError';
import { SessionManagementService } from '../../../../sessionManagement/SessionManagementService';
import { Sites } from '../../../../siteManagement/services/resources/Sites';

export interface DataConnectSiteSettingsSubspaceProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
  readonly server: SessionManagementService;
  readonly isSessionMultiSite: boolean;
  readonly isSessionServerAdmin: boolean;
}

export interface DataConnectSiteSettingsSubspaceState {
  readonly hasDataToRender: boolean;
  readonly hasError: boolean;
  readonly settings: ISiteDataConnectSettingsForSiteAdmin;
}

export class DataConnectSiteSettingsSubspace extends React.PureComponent<DataConnectSiteSettingsSubspaceProps, DataConnectSiteSettingsSubspaceState> {

  private unmounted: boolean = false;

  private initialState: DataConnectSiteSettingsSubspaceState = {hasDataToRender: false, settings: undefined, hasError: false};
  private sites = Sites.instance;

  public constructor(props: DataConnectSiteSettingsSubspaceProps) {
    super(props);
    this.state = this.initialState;
  }

  public componentDidMount() {
    this.getData();
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate(prevProps: DataConnectSiteSettingsSubspaceProps) {
    if (!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.updateState(this.initialState);
      this.getData();
      return;
    }

    if (!_.isUndefined(this.state.settings)) {
        this.updateState({hasDataToRender: true});
    }
  }

  public render() {
    if (!this.state.hasDataToRender) {
      return null;
    } else if (this.state.hasError) {
      return <RouterError errorType={'default'} urls={this.props.urls} />;
    }

    return (
      <div className={subspaceStyle}>
        <DataConnectSiteSettingsCoordinator {...this.state}/>
      </div>
    );
  }

  private updateState<K extends keyof DataConnectSiteSettingsSubspaceState>(newState: Pick<DataConnectSiteSettingsSubspaceState, K>, callback?: () => void): void {
    if (!this.unmounted) {
      this.setState(newState, callback);
    }
  }

  private getData = async () => {
    try {
      await this.props.server.getSessionInfoPromise();
      const settings = await this.sites.getCurrentSiteDataConnectSettingsForSiteAdmin();
      this.updateState({settings});
    } catch (e) {
      this.updateState({hasError: true});
    }
  };
}
